<template>
  <div class="battle-create">
    <div class="zz-page create-battle-page">
      <div class="page-content-new flex-box-view">
        <otherHeaderTop
          headerTitle="盲盒对战"
          :showBack="true"
          @back="back()"
          :showBalanceOne="false"
        ></otherHeaderTop>
        <div class="detail-content">
          <!-- <div class="page-content-bg">
            <div class="bg-layer1" style="margin-top: 16 * 4.2px"></div>
            <div class="bg-layer2" style="margin-top: 16 * 4.2px"></div>
          </div> -->
          <div class="abs-full">
            <div class="inner-content">
              <div class="tab-box">
                <div class="bt-tab-view">
                  <div
                    class="tab-bg"
                    style="display: flex; justify-content: space-around"
                  >
                    <div class="amount-tab">
                      <div
                        @click="changeTab(index, cate)"
                        :name="index"
                        v-for="(cate, index) in cates"
                        :key="index"
                        class="tab-item"
                        :class="[curTab == index ? 'active' : '']"
                      >
                        {{ cate.name }}
                      </div>
                    </div>
                  </div>

                  <div class="type-tab-wrap" style="font-size: 26rpx">
                    <div
                      @click.stop="
                        handleChangeType(
                          cate.boxTypeId,
                          cate.boxTypeName,
                          index
                        )
                      "
                      class="type-tab-item"
                      :name="index"
                      v-for="(cate, index) in headerNav"
                      :key="index"
                      :class="[cate.boxTypeId == currentId ? 'sel' : '']"
                    >
                      <span>{{ cate.boxTypeName }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box-list">
                <div class="create-pk-room-content">
                  <div class="box-list-wrap">
                    <div
                      @click="selectBox(item)"
                      class="box-list-item"
                      :class="[item.selected ? 'is-selected' : '']"
                      v-for="(item, index) in boxList"
                      :key="index"
                    >
                      <div class="select-opt-box">
                        <div
                          v-if="item.selected"
                          class="abs-base sel-num"
                          style=""
                        >
                          {{ item.boxNum }}
                        </div>
                        <div
                          @click.stop="openDetail(item)"
                          class="detail-btn"
                          style="color: rgb(146, 161, 190)"
                        ></div>
                        <div
                          v-if="item.selected"
                          @click.stop="minusBox(item)"
                          class="clear-all-btn"
                        ></div>
                      </div>
                      <div class="box-img">
                        <img
                          style="width: 70%; z-index: 9; left: 16%"
                          :src="`${$getFullPath(item.boxImg02)}`"
                          class="box-img"
                          mode="aspectFit"
                        />
                        <img
                          :src="`${$getFullPath(item.boxImg01)}`"
                          class="box-img"
                          mode="aspectFit"
                        />
                      </div>
                      <div class="box-info">
                        <div class="box-name text-ellipsis">
                          {{ item.boxName }}
                        </div>
                        <div class="box-price" style="margin-top: -1px">
                          <img src="../../assets/home/jinbi.png" class="coin" />
                          <span class="price">{{ item.price }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="btm-box"
          :class="[selectBoxes.length == 0 ? 'fold-box1' : '']"
        >
          <div class="fold-inner">
            <div class="top-info">
              <div class="cancel-all" @click="cancelAll()">全部取消</div>
              <div class="sel-num">
                {{ selectBoxes.length }} /
                {{ config.battle_create_box_number }} 件
              </div>
            </div>
            <div
              class="sel-box-list"
              @mousedown="onMouseDown"
              @mousemove="onMouseMove"
              @mouseup="onMouseUp"
            >
              <div class="sel-box-inner">
                <div
                  class="box-item"
                  v-for="(item, index) in selectBoxes"
                  :key="index"
                >
                  <div class="del-tag" @click="delBox(item)"></div>
                  <img
                    :src="`${$getFullPath(item.boxImg01)}`"
                    class="abs-full img"
                    mode="aspectFit"
                  />
                  <img
                    style="width: 70%; z-index: 9; left: 16%"
                    :src="`${$getFullPath(item.boxImg02)}`"
                    class="abs-full img"
                    mode="aspectFit"
                  />
                  <div class="price">{{ item.price }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="opt-box">
            <div class="amount-total">
              <img src="../../assets/home/jinbi.png" class="coin" />
              <span>{{ selectAmount }}</span>
            </div>
            <div>
              <div class="create-btn create-btn1" @click="openCreate(3)">
                创建三人
              </div>
              <div class="create-btn create-btn2" @click="openCreate(2)">
                创建双人
              </div>
            </div>
          </div>
          <!-- <div class="bottom-content">
          
            <div class="opt-box">
              <div class="amount-total">
                <img src="../../assets/images/balance1.png" class="coin" />
                <span>{{ selectAmount }}</span>
              </div>
              <div class="create-btn create-btn1" @click="openCreate(3)">
                创建三人
              </div>
              <div class="create-btn create-btn2" @click="openCreate(2)">
                创建双人
              </div>
            </div>
          </div> -->
        </div>
        <template> </template>
      </div>
    </div>
    <!-- 盲盒详情 -->
    <modalBoxDetail
      :showModal="showDetail"
      :info="curBox"
      @close="showDetail = false"
    ></modalBoxDetail>
    <!-- 创建对战 -->
    <modalBattleCreate
      :showModal="showBattleCreate"
      @change="changeBattleCreate"
      @doCreate="doCreate"
      :persons="persons"
      :boxNumber="selectBoxes.length"
      :boxAmount="selectAmount"
      @close="showBattleCreate = false"
    ></modalBattleCreate>
  </div>
</template>

<script>
import boxDetail from "./boxDetail.vue";
import otherHeaderTop from "@/components/otherHeaderTop.vue";
import modalBoxDetail from "@/components/common/modalBoxDetail.vue";
import modalBattleCreate from "@/components/common/modalBattleCreate.vue";
import {
  createFight,
  getUserInfo,
  getBoxList,
  /*   getBoxTypeList, */
} from "@/api/index";
export default {
  components: {
    boxDetail,
    otherHeaderTop,
    modalBoxDetail,
    modalBattleCreate,
  },
  data() {
    return {
      show_create_room: false,
      istypeshow: false,
      boxtype: "",
      selectedmodel: 0,
      people: 2,
      isCreat: false,
      model: 0,
      boxList: [],
      changeboxList: [],
      boxTypeList: [],
      money: 0,
      obj: {
        boxData: [],
        createNum: 0,
      },
      headerNav: [],
      boxobj: {},
      objj: {
        /*    boxIdAndNumber:null, */

        boxIdAndNumber: { 53: 2, 54: 2, 55: 1, 56: 1 },
        model: 0, //模式
        playerNumber: 2, //人数
      },
      boxPage: {
        page: 1,
        size: 10,
        gameMouldId: 2,
        boxTypeId: "",
        orderByFie: 2,
      },
      typePage: {
        page: 1,
        size: 10,
      },
      isOver: "加载中",
      boxDetail: {
        flag: false,
        boxId: "",
      },
      currentId: 0,
      // 新的
      cates: [{ name: "经典模式" }, { name: "非酋模式" }],
      curTab: 0,
      lists: [],
      page: 1,
      limit: 50,
      isOver: false,
      selectBoxes: [],
      selectAmount: 0,
      config: {
        battle_create_box_number: 10,
      },
      scrollLeft: 0,
      showBattleCreate: false,
      persons: 2,
      user: {},
      curBox: {},
      showDetail: false,
      debouncedCreateBattle: null,
      boxSequence: "",
    };
  },

  mounted() {
    this.getBox();
    this.getuser();
  },
  computed: {
    totalround() {
      return this.obj.boxData.reduce((total, box) => total + box.boxNum, 0);
    },
    totalmoney() {
      let bean = 0;
      this.obj.boxData.forEach((item) => {
        bean += item.price * item.boxNum;
      });
      return bean.toFixed(2);
    },
  },
  methods: {
    handleChangeType(res, name, index) {
      this.currentId = res;
      // this.boxList.map((item) => {
      //   item.selected = false;
      //   item.boxNum = null;
      // });
      this.boxList = this.headerNav[index].boxList;
      // 按价格升序排序 boxList
      // this.boxList.sort((a, b) => a.price - b.price);
      // console.log(this.boxList, "切换");
    },
    onMouseDown(event) {
      this.isDragging = true;
      this.startX = event.clientX;
    },
    onMouseMove(event) {
      if (this.isDragging) {
        const moveX = event.clientX - this.startX;
        const container = document.getElementsByClassName("sel-box-list")[0];
        container.scrollLeft -= moveX;
        this.startX = event.clientX;
      }
    },
    onMouseUp() {
      this.isDragging = false;
    },
    changeTab(index, cate) {
      this.curTab = index;
      // this.refresh();
    },
    openDetail(item) {
      this.$soundPlay("click");
      this.showDetail = true;
      this.curBox = item;
    },
    changeShowDetail() {},
    openCreate(persons) {
      if (this.selectBoxes.length <= 0) {
        this.$message({
          duration: 1000,
          message: "请选择箱子",
          type: "warning",
          customClass: "log_warning",
        });
        return;
      }
      this.persons = persons;
      this.showBattleCreate = true;
    },
    changeBattleCreate() {},
    doCreate() {
      // 使用Set来跟踪已经处理过的boxId
      const seenBoxIds = new Set();
      // 使用reduce函数来处理数据
      const result = this.selectBoxes.reduce((accumulator, currentValue) => {
        // 如果当前的 boxId 还没有被处理过，则初始化为 0
        if (!accumulator[currentValue.boxId]) {
          accumulator[currentValue.boxId] = 0;
        }
        // 累加当前箱子的数量到对应的 boxId
        accumulator[currentValue.boxId] += 1;

        return accumulator;
      }, {});
      const params = {
        boxIdAndNumber: result,
        model: this.curTab,
        playerNumber: this.persons,
        boxSequence: this.boxSequence,
      };
      // 请求服务器创建对战
      createFight(params).then((res) => {
        if (res.data.code == 200) {
          this.$bus.$emit("show_create_room", false);

          // 提示
          this.$message({
            duration: 1000,
            type: "success",
            message: "创建成功",
            customClass: "log_success",
          });

          // 跳转
          setTimeout(() => {
            this.$router.replace({
              name: "battleroom",
              query: {
                id: res.data.data.id,
                uid: this.userId,
                currentRound: 0,
                battleStatus: 0,
              },
            });
          }, 500);
        } else {
          this.$message({
            duration: 1000,
            type: "warning",
            message: res.data.msg,
            customClass: "log_warning",
          });
        }
      });
    },
    createBattle() {},
    selectBox(item) {
      // console.log("选择箱子", item);
      if (
        this.selectBoxes.length >=
        parseInt(this.config.battle_create_box_number)
      ) {
        this.$message({
          duration: 1000,
          message: `已超过最大箱子数 ${this.config.battle_create_box_number}`,
          type: "warning",
          customClass: "log_warning",
        });
        return;
      }
      item.selected = true;
      item.boxNum ? item.boxNum++ : (item.boxNum = 1);
      this.$forceUpdate();
      this.calcSelectBox(item);
      this.$nextTick((e) => {
        const container = document.getElementsByClassName("sel-box-list")[0];
        container.scrollLeft = 99999999 + Math.random();
      });
    },
    minusBox(item) {
      if (item.boxNum <= 1) {
        item.selected = false;
        item.boxNum = null;
      } else {
        item.boxNum--;
      }
      this.$forceUpdate();
      this.calcSelectBox(item, "minus");
      this.$nextTick((e) => {
        const container = document.getElementsByClassName("sel-box-list")[0];
        container.scrollLeft = 99999999 + Math.random();
      });
    },
    delBox(itm, index) {
      this.headerNav.forEach((item) => {
        item.boxList.forEach((item2) => {
          if (item2.boxId == itm.boxId) {
            item2.selected = false;
            item2.boxNum = null;
          }
        });
      });
      this.$forceUpdate();
      this.calcSelectBox(itm, "del");
    },
    calcSelectBox(item, type = "add") {
      // console.log("计算选中箱子", this.headerNav);
      // 获取当前已选中的箱子和总金额
      let currentSelectAmount = 0;
     
      if (type == "add") {
        const newId = Date.now();
        this.selectBoxes.push({ ...item, uniqueId: newId });
      } else if (type == "del") {
        this.selectBoxes = this.selectBoxes.filter(
          (box) => box.uniqueId !== item.uniqueId
        );
      } else if (type == "minus") {
        let indexToRemove = -1;

        // 遍历数组，找到最后一个匹配的索引
        for (let i = this.selectBoxes.length - 1; i >= 0; i--) {
          if (this.selectBoxes[i].boxId === item.boxId) {
            indexToRemove = i;
            break;
          }
        }

        // 如果找到匹配的索引，则移除该箱子
        if (indexToRemove !== -1) {
          this.selectBoxes.splice(indexToRemove, 1);
        }
      }
      this.selectBoxes.forEach((item, index) => {
        // console.log("当前选中的箱子和总金额", item);
        currentSelectAmount += parseFloat(item.price);
        if (index === 0) {
          this.boxSequence = item.boxId.toString(); // 第一个箱子直接赋值
        } else {
          this.boxSequence += "," + item.boxId; // 后续箱子用逗号分隔
        }
      });
      // console.log("当前选中的箱子和总金额", currentSelectAmount);
      // 更新 this.selectAmount，并确保保留两位小数
      this.selectAmount = Number(currentSelectAmount).toFixed(2);
    },
    getCate() {},
    cancelAll() {
      this.boxList.forEach((item) => {
        item.selected = false;
        item.boxNum = null;
      });
      this.selectBoxes = [];
      this.$forceUpdate;
    },
    refresh() {},
    getLists() {},
    // 新的
    back() {
      this.$router.go(-1);
    },
    getBoxDetail(boxId) {
      console.log(boxId);
      this.boxDetail.flag = true;
      this.boxDetail.boxId = boxId;
    },
    handleScroll(e) {
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight >=
        e.srcElement.scrollHeight
      ) {
        if (this.isOver == "加载中") {
          this.boxPage.page++;
          setTimeout(() => {
            this.getBox();
          }, 5);
        }
      }
    },
    playAudio() {
      this.$store.commit("playAudio");
    },
    //设置房间人数
    selectpeople(res) {
      this.objj.playerNumber = res;
    },
    //获取用户信息
    getuser() {
      getUserInfo().then((res) => {
        if (res.data.code == 200) {
          this.userId = res.data.data.userId;
          console.log(this.userId);
        }
      });
    },
    //设置房间类型
    selectmodel(res) {
      this.objj.model = res;
      console.log(this.objj);
    },
    //箱子的类别

    //获取全部的箱子
    getBox() {
      let data = {
        boxType: 2,
      };
      getBoxList(data).then((res) => {
        if (res.data.code == 200) {
          let arr = res.data.data;
          this.headerNav = arr;
          this.currentId = arr[0].boxTypeId;
          this.headerNav.map((item) => {
            item.selected = false;
            item.boxNum = null;
          });
          this.boxList = this.headerNav[0].boxList;
          // 按价格升序排序 boxList
          // this.boxList.sort((a, b) => a.price - b.price);
          if (res.data.data.length < this.boxPage.size) {
            this.isOver = "暂无更多";
          }
        }
      });
    },

    /* 关闭 */
    handleclose() {
      const element = this.$refs.slider;
      element.classList += " animate__fadeOutDown";
      setTimeout(() => {
        this.boxList = [];
        this.changeboxList = [];
        this.boxTypelist = [];
        this.$bus.$emit("show_create_room", false);
        this.$router.back();
        this.obj = {
          boxData: [],
          createNum: 0,
          model: 0,
        };
        this.boxTypelist = [];
      }, 350);
    },
    //创建房间
    handleCreat() {
      /*  console.log(this.objj)
      createFight(this.objj).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.$message({ duration: 1000,
            type: "success",
            message: "创建成功",
            customClass: "log_success",
          });
          this.$router.push({
            name: "battleroom",
            query: {
              id: res.data.data.id,
              uid: this.userId,
            },
          });
        } else {
          this.$message({ duration: 1000,
            type: "warning",
            message: res.data.msg,
            customClass: "log_warning",
          });
        }
      }); */
      if (this.objj.boxIdAndNumber) {
        const obj = Array.from(this.objj.boxIdAndNumber).reduce(
          (obj, [key, value]) => Object.assign(obj, { [key]: value }),
          {}
        );
        this.objj.boxIdAndNumber = obj;
        console.log("创建房间数据", this.objj);
        // 请求服务器创建对战
        createFight(this.objj).then((res) => {
          if (res.data.code == 200) {
            this.$bus.$emit("show_create_room", false);
            // this.$router.back()
            // this.handleclose();
            // 提示
            this.$message({
              duration: 1000,
              type: "success",
              message: "创建成功",
              customClass: "log_success",
            });

            // 跳转
            // this.$router.back()
            setTimeout(() => {
              this.$router.replace({
                name: "battleroom",
                query: {
                  id: res.data.data.id,
                  uid: this.userId,
                },
              });
            }, 500);
          } else {
            console.log("api/fight/createFight 异常");
            this.$message({
              duration: 1000,
              type: "warning",
              message: res.data.msg,
              customClass: "log_warning",
            });
          }
        });
      }

      /*  const round = this.obj.boxData.reduce(
        (total, box) => total + box.boxNum,
        0
      );
      this.obj.rounds = round;
      createFight(this.obj).then((res) => {
        console.log(res)
        if (res.data.code == 200)
          this.$message({ duration: 1000,
            type: "success",
            message: res.data.msg,
            customClass: "log_success",
          });
        this.handleclose();
        this.$router.push({
          name: "battleroom",
          query: {
            id: res.data.data.id,
          },
        });
      }, 199); */
    },
    handleDel(res) {
      console.log(res);
      if (res.boxNum <= 0) {
        return;
      } else {
        console.log("减", this.objj.boxIdAndNumber);
        if (!this.objj.boxIdAndNumber.set) {
          // console.log('不是map');
          let map = new Map();
          let key;
          for (key in this.objj.boxIdAndNumber) {
            map.set(key, this.objj.boxIdAndNumber[key]);
          }

          this.objj.boxIdAndNumber = map;
        }
        this.objj.boxIdAndNumber.set(res.boxId, res.boxNum - 1);
        // console.log(this.objj.boxIdAndNumber);
        this.$set(res, "boxNum", res.boxNum - 1);
        // console.log(res);
        // res.boxNum -= 1;
        this.$forceUpdate();
        /* map1.delete(); */
        this.obj.boxData.forEach((item) => {
          if (item.boxNum === 0) {
            let index = this.changeboxList.indexOf(item); // 获取元素在数组中的索引位置
            this.obj.boxData.splice(index, 1); // 从数组中移除该元素
          }

          /*  else {
        //     // this.$forceUpdate();
        //     // this.totalround = 0;
        //     // this.obj.boxData.forEach(item => {
        //     //   this.totalround += item.boxNum;
        //     // });
        //   } */
        });
      }
    },
    handlePush(res) {
      if (this.obj.boxData.length == 6 && res.boxNum == 0) {
        this.$message({
          duration: 1000,
          type: "warning",
          message: "最多选择6种盲盒",
          customClass: "log_warning",
        });
        return false;
      }
      if (this.totalround < 12) {
        res.boxNum += 1;
        let index = this.changeboxList.findIndex(
          (item) => item.boxId === res.boxId
        );
        // 如果有就替换，没有就添加
        if (index !== -1) {
          this.changeboxList.splice(index, 1, res);
        } else {
          this.changeboxList.push(res);
        }
        let sum = 0;
        this.changeboxList.forEach((obj) => {
          sum += obj.boxNum; // 将每个对象的 value1 值相加到 sum 上
          this.money += obj.price;
        });
        /* console.log(this.changeboxList) */
        const map1 = new Map();
        this.changeboxList.forEach((v) => {
          map1.set(v.boxId, v.boxNum);
        });

        this.objj.boxIdAndNumber = map1;
        /*     console.log(this.objj.boxIdAndNumber) */

        /*  boxobj */
        this.obj.createNum = sum;
        this.obj.boxData = this.changeboxList;
      } else {
        this.$message({
          duration: 1000,
          type: "warning",
          message: "选择数量超出最大限制",
          customClass: "log_warning",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/style/bt_tab.scss";

// 新的
.battle-create {
  --head-height: 14 * 4.2px;
}

.create-battle-page .page-content-new {
  padding-bottom: 25.6 * 4.2px;
}

.create-battle-page .page-content-new .detail-content {
  z-index: 1;
  position: relative;
  // -webkit-box-flex: 1;
  // -webkit-flex: 1;
  // -ms-flex: 1;
  // flex: 1;
  width: 100%;
  height: calc(100vh - 180px);
}

.create-battle-page .page-content-new .detail-content .inner-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.create-battle-page .page-content-new .detail-content .inner-content .tab-box {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 148.4px;
  padding-top: 2 * 4.2px;
}

.create-battle-page .page-content-new .detail-content .inner-content .box-list {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.create-battle-page .btm-box {
  z-index: 2;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 44 * 4.2px;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.create-battle-page .btm-box .top-info {
  position: relative;
  height: 8.4 * 4.2px;
  background-size: 100% 100%;
  // background-image: url("../../assets/images/top-info.png");
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAu4AAAB2BAMAAABlmQv+AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAASUExURUNWg0JXgkJXgkNWg0NWg0JWg0ADukgAAAAGdFJOU+bX38/h3LmqeKcAAADBSURBVHja7dBRCQAgEAWwh1jABpbw3w7272KLE2GLsKxBvZMd6vVMCQ80796949073r3j3TvevePdu3e8e8e7d7x7x7t3vHv3jnfvePeOd+94945373j37h3v3vHuHe/e8e4d796949073r3j3TvevePdu3e8e8e7d7x7x7t3vHvHu3fvePeOd+94945373j37h3v3vHuHe/e8e4d7969S/DuHe/e8e4d797x7h3v3r3j3TveveP9u/ct4YGeNah3Lu5uQkc2sktNAAAAAElFTkSuQmCC);
}

.create-battle-page .btm-box .top-info .cancel-all {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  float: left;
  width: 23.33 * 4.2px;
  height: 8.4 * 4.2px;
  line-height: 8.4 * 4.2px;
  text-align: center;
  color: #58deff;
  font-size: 3.33 * 4.2px;
  padding: 0 0 0 2 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/creatroom/20.png");
  // background-image: url("../../assets/images/cancel-all.png");
}

.create-battle-page .btm-box .top-info .sel-num {
  float: right;
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
  color: #fff;
  padding: 3.07 * 4.2px 5.87 * 4.2px 0 0;
}

.create-battle-page .btm-box .top-info .folder-btn {
  position: absolute;
  top: 2 * 4.2px;
  left: 47.33 * 4.2px;
  width: 5.33 * 4.2px;
  height: 2.93 * 4.2px;
  -webkit-transform: rotateX(0deg);
  transform: rotateX(0deg);
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAWCAMAAACFUC6CAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAHsUExURQAAACpV/wBV/yRb/wAAAACA/wAA/wAAQAMFEAMHEwAAAAAAADNm/wAAAFVV/wADCAMFDSBg/wMHFCZZ/wAAAAAAAAAAAAAAAAAAVSJV/ypq/0CA/yhe/yJd/wECByxZ/wIGDyde/y5d/wECBSdd/yNY/0Bg/yZZ/yRJ/ydd/wIGDiRb/yhb/yhb/yZb/y5d/yZb/yZb/ypg/wwdUQYPKv7+/2R9zBYwhKKz6ODn+f///y5LpgAAAAUNJA8lZwoYQwUMIhEobwAAAQEDBwEDCQEDCAQJGAULHwgSMgECBgULHgQIFgcRLg0eUwoYRZOdvhMtfwMIFwYPKQMHFBk6owgUOBxCuQMGEAQJGvv8/VBjnPX3+4qVt+/y/YCTz+3x/QsbTBEdQoKY3AQKHBUrbQkUON7j86Kw2BMpbA0eVBk2jgwcTQgUNwoZRQoXPnmMxmN5wCtGlw4gWxo1iAcRMBUvgA8kZeDm+KKy5Bsydg8kZAweVAoYQhUwhAkVPHiJuhYxhBUwgwscTQsbSy1KowoXQGR9yuDm+RAlaQsaSQsZRi1LpQcQLBAmbAgTNAwdUAsbShAnbBEocGR+zi5Mp2R9yQcQLTZf3ODn+/39/+Hn+qO06g0fVaq//xc2l+Dn+t7k9xEpcTBQtaO38kjvcXIAAAAzdFJOUwAGAw4DAgEEYOFcXQXfA15fCOEobAXo4AMPDAQTHuAX4S4W4CEdCBQHNOA4TC1fCzVrGJJ3HJQAAAHxSURBVCjPY2AAATZWPmk+VjYgg4mHUVBNTZCRh4kNSRgGWBmlZJTUmQWZmBiZ5*4.2pxEdXWFVeSZGZmYBJnVlWSkGFnhCnkkZRW1DYSN9DWYVTV19AwN9XQ0VZk19I2EDbQVZSV5wIpExGxsnN08jO3sMnOSwwN9fANCwsJCAnx9AsOTczLt7Iw93JxtbMREGES5xZ1c3O39I9MLy+ocHBJjoq2AIDom0cGhrqwwPdLf3t3FSZxblIGBhYvX1csvKs20oqWjtSQvJS7Wyio2LiWvpLWjpcI0LcrPy5WXiwVkOQuXnHdoRkG5qUV3b2dNUVZSfHxSVlFNZ2+3hWl5QUaotxxEHVAlv4JtQmlbu6mFtaNxU1Vxfn5xVZOxo7WFaXtbaYKtAj8LzNcSApxBxrVmlkCVk/q7mqurm7v6JwH*4.2pxZrVGgdxCkggApKdQ8jE2Bys0nFCX09P3wRHsDpzYxMhDnYGBmSVnDCVE+2nTbOfCFPHiaoOWeWUhXPmLJyCSx2SytmL5s1bNBunOrjK+aaLp09fbDofpzq4ylkz586dOQuPOqjKhskzrKxmTG7Aow6qsnHqggVTG/Gqg4RndmV9fWU2evhhMdM2NTc31ZYTvzqgSgGt4IiIYC0BAuqAKvmVPT2V+QmqA6Ylbl5ebhYMYQDvFYSD+dlmYwAAAABJRU5ErkJggg==);
}

.create-battle-page .btm-box .sel-box-list {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 15.73 * 4.2px;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  opacity: 1;
  overflow-x: scroll;
  overflow-y: hidden;
  background-size: 100% 100%;
  background: rgba(0, 0, 0, 0.7);
  // background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAu4AAAB2BAMAAABlmQv+AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAASUExURUNWg0JXgkJXgkNWg0NWg0JWg0ADukgAAAAGdFJOU+bX38/h3LmqeKcAAADBSURBVHja7dBRCQAgEAWwh1jABpbw3w7272KLE2GLsKxBvZMd6vVMCQ80796949073r3j3TvevePdu3e8e8e7d7x7x7t3vHv3jnfvePeOd+94945373j37h3v3vHuHe/e8e4d796949073r3j3TvevePdu3e8e8e7d7x7x7t3vHvHu3fvePeOd+94945373j37h3v3vHuHe/e8e4d7969S/DuHe/e8e4d797x7h3v3r3j3TveveP9u/ct4YGeNah3Lu5uQkc2sktNAAAAAElFTkSuQmCC);
}

.create-battle-page .btm-box .sel-box-list::-webkit-scrollbar {
  height: 2px;
}

.create-battle-page .btm-box .sel-box-list .sel-box-inner {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0 1.33 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.create-battle-page .btm-box .sel-box-list .box-item {
  position: relative;
  width: 16.4 * 4.2px;
  height: 15.73 * 4.2px;
  margin: 0 4.53 * 4.2px 0 0;
}

.create-battle-page .btm-box .sel-box-list .box-item .del-tag {
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  width: 2.67vw;
  height: 2.67vw;
  background-size: 100% 100%;
  background: url("~@/assets/creatroom/19.png") no-repeat center center;
}

.create-battle-page .btm-box .sel-box-list .box-item .img {
  width: 100%;
  height: 100%;
  -o-object-fit: scale-down;
  object-fit: scale-down;
}

.create-battle-page .btm-box .sel-box-list .box-item .price {
  position: absolute;
  left: 0;
  bottom: 1.33 * 4.2px;
  width: 100%;
  height: 4.8 * 4.2px;
  line-height: 4.8 * 4.2px;
  font-size: 3.33 * 4.2px;
  color: #fff;
  text-align: center;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAAkCAMAAAB19g5sAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA/UExURTIybTIybDIybSoqajIybjMzZjIybTExbTIybQAAADIybjExbjIybDIybTIybDExbDIybkBAajIybjMzbDExbWHlVyQAAAAVdFJOU8zBwgxmCsPAvgBrur3AwsSzDMFqafJa6tcAAABpSURBVFjD7djbDYAgAEPRIogWVHztP6tMQRPTu8D5bkEyli0vQwvtBDmngOFldPcY72JFlLgdfgM0cIUI3lXwatiwYcOGDRs2bNjwX+BdBVcRfD8aeEpRAk9pZl/IEpc4Wxh7Q+StXCQ/YvsJeIQKL7wAAAAASUVORK5CYII=);
}

.create-battle-page .btm-box .opt-box {
  z-index: 3;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 19.6 * 4.2px;
  font-size: 4.4 * 4.2px;
  font-weight: 700;
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: 100% 14.53 * 4.2px;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2vw;
  // background-image: url("../../assets/images/app_ft_2.png");
  // background-color: #1e1d32;
}

.create-battle-page .btm-box .opt-box .amount-total {
  float: left;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 7.07 * 4.2px;
  color: #fff;
  // margin: 2.27 * 4.2px 0 0 1.73 * 4.2px;
}

.create-battle-page .btm-box .opt-box .amount-total .coin {
  width: 6.6 * 4.2px;
  height: 6.07 * 4.2px;
  margin-right: 0.67 * 4.2px;
}

.create-battle-page .btm-box .opt-box .create-btn {
  float: right;
  width: 29.07 * 4.2px;
  height: 9.07 * 4.2px;
  line-height: 9.07 * 4.2px;
  text-align: center;
  background-size: 100% 100%;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
}

.create-battle-page .btm-box .opt-box .create-btn1 {
  margin: 2.13 * 4.2px 3.6 * 4.2px 0 0;
  background-image: url("../../assets/creatroom/18.png");
}

.create-battle-page .btm-box .opt-box .create-btn2 {
  margin: 2.13 * 4.2px 1.87 * 4.2px 0 0;
  background-image: url("../../assets/creatroom/17.png");
}

.create-battle-page .btm-box.fold-box1 {
  height: 28.27 * 4.2px;
}

.create-battle-page .btm-box.fold-box1 .sel-box-list {
  opacity: 0.5;
}

.create-battle-page .btm-box.fold-box1 .folder-btn {
  -webkit-transform: rotateX(180deg);
  transform: rotateX(180deg);
}

.create-battle-page .sort-wrap {
  height: 4.27 * 4.2px;
  margin: 2 * 4.2px 0 4 * 4.2px 1.33 * 4.2px;
  position: relative;
  z-index: 5;
}

.create-battle-page .sort-wrap .left-sort-box .sort {
  width: auto;
  height: 4.27 * 4.2px;
  line-height: 4.27 * 4.2px;
  color: #ecf0f9;
  font-weight: 600;
  cursor: pointer;
  float: left;
  font-size: 3.2 * 4.2px;
}

.create-battle-page .goods-probability {
  padding: 11.214px 0 0 4 * 4.2px;
}

.create-battle-page .box-list {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.create-battle-page .create-pk-room-content {
  width: 100%;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  z-index: 5;
  padding-bottom: 1.33 * 4.2px;
}

.create-battle-page .create-pk-room-content.popup_opended {
  padding-bottom: 16 * 4.2px;
}

.create-battle-page .box-list-wrap {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 1.33 * 4.2px 0 0 1.33 * 4.2px;
}

.create-battle-page .box-list-wrap.padding-bottom-542 {
  padding-bottom: 72.27 * 4.2px;
}

.create-battle-page .box-list-wrap.padding-bottom-1002 {
  padding-bottom: 133.6 * 4.2px;
}

.create-battle-page .box-list-wrap.padding-bottom-516 {
  padding-bottom: 68.8 * 4.2px;
}

.create-battle-page .box-list-wrap.padding-bottom-830 {
  padding-bottom: 110.67 * 4.2px;
}

.create-battle-page .box-list-wrap .box-list-item {
  position: relative;
  width: 28.13 * 4.2px;
  height: 25.87 * 4.2px;
  color: #fff;
  margin: 0 2.13 * 4.2px 2.13 * 4.2px;
  // background: url("../../assets/images/box_item_bg1.png") center center / 100%
  //   100%;
  background: linear-gradient(180deg, #5b1ce3 0%, #320f7d 100%);
  box-shadow: inset 0px 0px 6px 0px #6ba0cd;
  border-radius: 2px 2px 2px 2px;
  border: 0px solid #b378e0;
}

.create-battle-page .box-list-wrap .box-list-item.is-selected {
  background: url("~@/assets/creatroom/16.png");
  background-size: 100% 100%;
}

.create-battle-page .box-list-wrap .box-list-item .detail-btn {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 5.47 * 4.2px;
  height: 4.13 * 4.2px;
  background: url("../../assets/images/detail-btn-top.png") no-repeat top 1.68px
      center / 11.214px 11.214px,
    url("../../assets/images/detail-btn-bottom.png") center center / 100% 100%;
}

.create-battle-page .box-list-wrap .box-list-item .select-opt-box {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.create-battle-page .box-list-wrap .box-list-item .select-opt-box .sel-num {
  width: 7.33 * 4.2px;
  height: 4.67 * 4.2px;
  line-height: 4.67 * 4.2px;
  font-size: 3.33 * 4.2px;
  color: #fff;
  text-align: center;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAAjBAMAAADCso/4AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAYUExURWE5FQAAANOdL//DOP/FNv/FNv/COf/ENxz9AZIAAAAHdFJOU78Ar4B/wD++Rr5zAAAAV0lEQVQoz2Moxw0KGGgmyYADsI9KjkoSllTHI8lUHoBbUr1UAKckU7khbkn1YkGckkCNgg64JIEaRXC5FqQxHZckUKMYrrwC1ogzl5UKiuDOgoGC7kBJAKx5eyEPYkqDAAAAAElFTkSuQmCC);
}

.create-battle-page .box-list-wrap .box-list-item .select-opt-box .num-opt-box {
  position: absolute;
  left: 50%;
  top: 44%;
  width: 25.33 * 4.2px;
  height: 5.33 * 4.2px;
  margin-top: -3.73 * 4.2px;
  margin-left: -111.214px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  overflow: hidden;
  -webkit-border-radius: 11.214px;
  border-radius: 11.214px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 21.33 * 4.2px 100%;
}

.create-battle-page
  .box-list-wrap
  .box-list-item
  .select-opt-box
  .num-opt-box
  .num-show-box {
  width: 11.2 * 4.2px;
  height: 5.33 * 4.2px;
  line-height: 5.33 * 4.2px;
  margin: 0 1.33 * 4.2px;
  font-size: 4 * 4.2px;
  font-weight: 700;
  text-align: center;
  color: #ecf0f9;
}

.create-battle-page
  .box-list-wrap
  .box-list-item
  .select-opt-box
  .num-opt-box
  .opt-btn {
  width: 5.73 * 4.2px;
  height: 5.33 * 4.2px;
  background-size: 100% 100%;
}

.create-battle-page
  .box-list-wrap
  .box-list-item
  .select-opt-box
  .clear-all-btn {
  position: absolute;
  right: 0;
  bottom: 6.27 * 4.2px;
  width: 6.67 * 4.2px;
  height: 4 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/clear-all-btn.png");
}

.create-battle-page .box-list-wrap .box-list-item .box-img {
  position: relative;
  height: 20 * 4.2px;
}

.create-battle-page .box-list-wrap .box-list-item .box-img .box-img {
  position: absolute;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;
  -o-object-fit: scale-down;
  object-fit: scale-down;
}

.create-battle-page .box-list-wrap .box-list-item .box-info {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  font-size: 3.33 * 4.2px;
  text-align: left;
  padding-left: 10px;
}

.create-battle-page .box-list-wrap .box-list-item .box-info .box-name {
  height: 4.8 * 4.2px;
  line-height: 4.8 * 4.2px;
}

.create-battle-page .box-list-wrap .box-list-item .box-info .box-price {
  height: 5.33 * 4.2px;
  line-height: 5.33 * 4.2px;
}

.create-battle-page .box-list-wrap .box-list-item .box-info .box-price text {
  padding-top: 0.27 * 4.2px;
  font-family: "Alimama ShuHeiTi", serif;
}

.create-battle-page .box-list-wrap .box-list-item .box-info .box-price .coin {
  width: 4.27 * 4.2px;
  height: 4.27 * 4.2px;
  margin-right: 0.27 * 4.2px;
}

.create-battle-page .pk-selected-popup-car {
  background: none;
  overflow: unset;
  z-index: 2000 !important;
}

.create-battle-page .pk-selected-popup-car .selected-car-popup-content {
  width: 100%;
  height: 120 * 4.2px;
  position: absolute;
  left: 0;
  bottom: 36.53 * 4.2px;
  z-index: 900;
  --duration: 0.2s;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#596886),
    to(#19243c)
  );
  background: -webkit-linear-gradient(top, #596886, #19243c 100%);
  background: -o-linear-gradient(top, #596886, #19243c 100%);
  background: linear-gradient(180deg, #596886, #19243c 100%);
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .close-box {
  position: absolute;
  top: -6.13 * 4.2px;
  left: 0;
  width: 100 * 4.2px;
  height: 8.27 * 4.2px;
  background-size: 100% 100%;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .close-box
  .close {
  position: absolute;
  top: 1.6 * 4.2px;
  right: 2.27 * 4.2px;
  width: 3.47 * 4.2px;
  height: 3.47 * 4.2px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-top {
  width: 100%;
  height: 10 * 4.2px;
  padding-top: 3.33 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-top
  .left {
  width: auto;
  height: 6.67 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #c9d5e5;
  font-size: 3.2 * 4.2px;
  padding-left: 3.2 * 4.2px;
  float: left;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-top
  .left
  .cancel-all {
  float: left;
  width: 19.33 * 4.2px;
  height: 5.73 * 4.2px;
  line-height: 5.73 * 4.2px;
  font-size: 3.2 * 4.2px;
  color: #fff;
  text-align: center;
  background-size: 100% 100%;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-top
  .left
  .sel-size {
  color: #3ad7ff;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-top
  .left
  .cancel-all-btn
  .arrow-img {
  display: inline-block;
  -webkit-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  transform: rotate(0deg);
  width: 5.6 * 4.2px;
  height: 4 * 4.2px;
  margin: 1.6 * 4.2px 0 0 1.33 * 4.2px;
  background-size: 100% 100%;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-top
  .close-btn {
  position: absolute;
  top: 4 * 4.2px;
  right: 2.8 * 4.2px;
  width: 4.27 * 4.2px;
  height: 3.73 * 4.2px;
  background-size: 100% 100%;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-wrap {
  width: 100%;
  height: 103.73 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  overflow-y: auto;
  margin-top: 3.73 * 4.2px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-wrap::-webkit-scrollbar {
  width: 1.33 * 4.2px;
  height: 1.33 * 4.2px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-wrap::-webkit-scrollbar-thumb {
  background: #666db1;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-wrap::-webkit-scrollbar-track {
  -webkit-border-radius: 0;
  border-radius: 0;
  background: #bfb0c6;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-wrap
  .box-item {
  position: relative;
  width: 93.6 * 4.2px;
  height: 17.33 * 4.2px;
  margin-bottom: 2.13 * 4.2px;
  background-size: 100% 100%;
  margin-left: 11.214px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-wrap
  .box-item
  .box-item-left {
  width: 611.214px;
  height: 15.33 * 4.2px;
  padding-left: 7.33 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-top: 0.67 * 4.2px;
  margin-right: 1.33 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  float: left;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-wrap
  .box-item
  .box-item-left
  .box-img {
  position: relative;
  width: 14.4 * 4.2px;
  height: 14.4 * 4.2px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-wrap
  .box-item
  .box-item-left
  .box-img
  img {
  width: 100%;
  height: 100%;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-wrap
  .box-item
  .box-item-left
  .box-info {
  width: 40.27 * 4.2px;
  height: 100%;
  padding-left: 11.214px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-wrap
  .box-item
  .box-item-left
  .box-info
  .box-name {
  font-size: 3.2 * 4.2px;
  color: #2f3f60;
  margin-top: 2 * 4.2px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-wrap
  .box-item
  .box-item-left
  .box-info
  .box-price {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 4.8 * 4.2px;
  line-height: 4.8 * 4.2px;
  color: #2f3f60;
  font-size: 4 * 4.2px;
  font-weight: 700;
  margin-top: 2 * 4.2px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-wrap
  .box-item
  .box-item-left
  .box-info
  .box-price
  text {
  font-family: "Alimama ShuHeiTi", serif;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-wrap
  .box-item
  .box-item-left
  .box-info
  .box-price
  .coin {
  width: 4.27 * 4.2px;
  height: 4.27 * 4.2px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-wrap
  .box-item
  .box-item-right {
  width: 28 * 4.2px;
  height: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  float: left;
  position: relative;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-wrap
  .box-item
  .box-item-right
  .num-opt-box {
  position: absolute;
  left: 48%;
  top: 72%;
  width: 25.33 * 4.2px;
  height: 5.33 * 4.2px;
  margin-top: -3.73 * 4.2px;
  margin-left: -111.214px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  overflow: hidden;
  -webkit-border-radius: 11.214px;
  border-radius: 11.214px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 21.33 * 4.2px 100%;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-wrap
  .box-item
  .box-item-right
  .num-opt-box
  .num-show-box {
  width: 11.2 * 4.2px;
  height: 5.33 * 4.2px;
  line-height: 5.33 * 4.2px;
  margin: 0 1.33 * 4.2px;
  font-size: 4 * 4.2px;
  font-weight: 700;
  text-align: center;
  color: #ecf0f9;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-wrap
  .box-item
  .box-item-right
  .num-opt-box
  .opt-btn {
  width: 5.73 * 4.2px;
  height: 5.33 * 4.2px;
  background-size: 100% 100%;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-popup-content
  .car-popup-content-wrap
  .box-item
  .clear-all {
  position: absolute;
  top: 1.33 * 4.2px;
  right: 4 * 4.2px;
  width: 4 * 4.2px;
  height: 4 * 4.2px;
  background-size: 100% 100%;
}

.create-battle-page .pk-selected-popup-car .selected-box-content {
  position: relative;
}

.create-battle-page .pk-selected-popup-car .selected-box-content .close-box {
  position: relative;
  height: 8.27 * 4.2px;
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  background-size: 100% 100%;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-box-content
  .close-box
  .close {
  position: absolute;
  top: 1.6 * 4.2px;
  right: 2.27 * 4.2px;
  width: 3.47 * 4.2px;
  height: 3.47 * 4.2px;
}

.create-battle-page .pk-selected-popup-car .selected-box-content .option-bar {
  height: 13.33 * 4.2px;
  font-size: 3.73 * 4.2px;
  margin-top: -1.33 * 4.2px;
  background-size: 100% 100%;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-box-content
  .option-bar
  .box-size {
  float: left;
  width: 25.07 * 4.2px;
  height: 10 * 4.2px;
  margin: 2 * 4.2px 0 0 1.33 * 4.2px;
  background-size: 100% 100%;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-box-content
  .option-bar
  .box-size
  .more-op {
  width: 5.07 * 4.2px;
  height: 5.07 * 4.2px;
  margin-right: 0.67 * 4.2px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-box-content
  .option-bar
  .box-size
  .len {
  font-weight: 700;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-box-content
  .option-bar
  .total-price {
  float: left;
  width: 43.33 * 4.2px;
  height: 9.2 * 4.2px;
  font-size: 4.8 * 4.2px;
  margin: 11.214px 0 0 2 * 4.2px;
  background-size: 100% 100%;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-box-content
  .option-bar
  .total-price
  .coin {
  width: 4.27 * 4.2px;
  height: 4.27 * 4.2px;
  margin: -1.68px 0.67 * 4.2px 0 0;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-box-content
  .option-bar
  .room-size {
  float: left;
  width: 25.07 * 4.2px;
  height: 10 * 4.2px;
  margin: 2 * 4.2px 0 0 1.87 * 4.2px;
  background-size: 100% 100%;
}

.create-battle-page .pk-selected-popup-car .selected-box-content .btn-box {
  height: 22.93 * 4.2px;
  background-size: 100% 100%;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-box-content
  .btn-box
  .create-btn {
  width: 40 * 4.2px;
  height: 10.67 * 4.2px;
  line-height: 10.67 * 4.2px;
  text-align: center;
  font-size: 3.73 * 4.2px;
  font-weight: 700;
  color: #fff2d7;
  margin: 0 6 * 4.2px;
  background-size: 100% 100%;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-box-content
  .btn-box
  .create-btn
  .btn-pre {
  width: 4.27 * 4.2px;
  height: 4.27 * 4.2px;
  margin-right: 0.67 * 4.2px;
}

.create-battle-page .pk-selected-popup-car .selected-car-content {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 57.33 * 4.2px;
  z-index: 1000;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .toggle-pk-type {
  position: absolute;
  left: 31.87 * 4.2px;
  top: 7.73 * 4.2px;
  width: 36 * 4.2px;
  height: 7.73 * 4.2px;
  line-height: 7.73 * 4.2px;
  z-index: 1300;
  font-size: 3.2 * 4.2px;
  color: #ecf0f9;
  text-align: center;
  background-size: 100% 100%;
}

.create-battle-page .pk-selected-popup-car .selected-car-content .toggle-btn {
  width: 42.8 * 4.2px;
  height: 7.2 * 4.2px;
  position: absolute;
  left: 50%;
  top: -7.07 * 4.2px;
  margin-left: -20.53 * 4.2px;
  text-align: center;
  line-height: 7.2 * 4.2px;
  z-index: 1250;
}

.create-battle-page .pk-selected-popup-car .selected-car-content .middle-btns {
  width: 100%;
  height: 8.53 * 4.2px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1250;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .middle-btns
  .opt-btn,
.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .middle-btns
  .toggle-btn {
  position: absolute;
  width: 40 * 4.2px;
  height: 7.2 * 4.2px;
  text-align: center;
  line-height: 7.2 * 4.2px;
  z-index: 950;
  font-size: 2.93 * 4.2px;
  color: #c9d5e5;
  --duration: 0.2s;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .middle-btns
  .sel-size {
  color: #3ad7ff;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-num-btn {
  width: 42.8 * 4.2px;
  height: 6.67 * 4.2px;
  background-size: 100% 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-num-btn
  .arrow-icon {
  font-size: 4 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding-right: 11.214px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-num-btn
  .arrow-icon
  .arrow-img {
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
  width: 5.6 * 4.2px;
  height: 4 * 4.2px;
  background-size: 100% 100%;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-num-btn
  .icon-active
  .arrow-img {
  -webkit-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  transform: rotate(0deg);
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .close-popup-btn {
  position: absolute;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  right: 1.47 * 4.2px;
  top: 1.73 * 4.2px;
  z-index: 1300;
  width: 5.33 * 4.2px;
  height: 5.33 * 4.2px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  position: absolute;
  left: 0;
  top: 0;
  padding-top: 9.33 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  z-index: 1210;
  margin-top: 5.07 * 4.2px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .base-info-row {
  width: 100%;
  height: 9.33 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 3.73 * 4.2px;
  font-weight: 700;
  color: #2f3f60;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .base-info-row
  .num-select-item {
  width: 45.07 * 4.2px;
  height: 12.27 * 4.2px;
  line-height: 11.33 * 4.2px;
  text-align: center;
  font-size: 4.27 * 4.2px;
  background-size: 100% 100%;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .base-info-row
  .num-select-item.num-select-item-active {
  color: #ecf0f9;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .base-info-row.num-select-box {
  height: 10.67 * 4.2px;
  margin-top: 11.214px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .base-info-row.num-select-box
  .num-select-item {
  margin: 0 4.67 * 4.2px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .base-info-row.num-select-box
  .num-select-item
  .svg-icon {
  font-size: 3.73 * 4.2px;
  margin-top: 1.68px;
  margin-right: 1.68px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .base-info-row.bottom-selected-info {
  height: 12 * 4.2px;
  margin-top: 10.67 * 4.2px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .base-info-row.bottom-selected-info
  .info-item {
  width: 23.47 * 4.2px;
  height: 10.67 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 3.2 * 4.2px;
  color: #c9d5e5;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .base-info-row.bottom-selected-info
  .info-item
  .num-btn {
  width: 211.214px;
  height: 8 * 4.2px;
  line-height: 8 * 4.2px;
  font-size: 3.2 * 4.2px;
  color: #ecf0f9;
  text-align: center;
  background: #8089a0;
  border-top: solid 1.68px #2f3f60;
  margin: 1.33 * 4.2px 2 * 4.2px 0 0;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .base-info-row.bottom-selected-info
  .info-item
  .num-btn
  .edit-ic {
  margin-left: 2 * 4.2px;
  font-size: 4 * 4.2px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .base-info-row.bottom-selected-info
  .info-item.submit-btn {
  width: 45.2 * 4.2px;
  height: 111.214px;
  font-size: 4 * 4.2px;
  font-weight: 700;
  color: #fff5dc;
  background-size: 100% 100%;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .base-info-row.bottom-selected-info
  .info-item.submit-btn
  .total-price {
  font-size: 4.27 * 4.2px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .base-info-row.bottom-selected-info
  .info-item.submit-btn
  .coin {
  width: 4.27 * 4.2px;
  height: 4.27 * 4.2px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .base-info-row.bottom-selected-info
  .info-item.submit-btn
  text:last-child {
  margin-left: 1.33 * 4.2px;
  color: #fff5dc;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .base-info-row.bottom-selected-info
  .info-item
  .img-icon {
  width: 3.2 * 4.2px;
  height: 3.2 * 4.2px;
  margin: 1.68px 0 0;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .base-info-row.bottom-selected-info
  .info-item
  .van-checkbox
  .van-checkbox__label {
  line-height: 4.8 * 4.2px;
  font-size: 3.2 * 4.2px;
  color: #2f3f60;
  padding-top: 0.67 * 4.2px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .base-info-row.bottom-selected-info
  .info-item
  .van-checkbox__icon {
  width: 3.47 * 4.2px;
  height: 3.47 * 4.2px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .base-info-row.bottom-selected-info
  .info-item
  .van-checkbox__icon
  .van-icon {
  width: 3.47 * 4.2px;
  height: 3.47 * 4.2px;
  line-height: 3.47 * 4.2px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .base-info-row.bottom-selected-info
  .info-item
  .van-checkbox__icon--checked
  .van-icon {
  color: #ff9f00;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .base-info-row.bottom-selected-info
  .info-item1 {
  background: none;
  padding-top: 0.8 * 4.2px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .robot-select-box {
  width: 100%;
  height: 10.67 * 4.2px;
  overflow-y: hidden;
  overflow-x: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  z-index: 1005;
  margin-top: 11.214px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .robot-select-box::-webkit-scrollbar {
  display: none;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .robot-select-box
  .scroll-box {
  width: auto;
  height: 10.67 * 4.2px;
  padding-left: 11.214px;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .robot-select-box
  .robot-select-item {
  display: block;
  float: left;
  width: 34.4 * 4.2px;
  height: 12.27 * 4.2px;
  line-height: 11.33 * 4.2px;
  margin-right: 2.27 * 4.2px;
  padding-left: 1.6 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #2f3f60;
  background-size: 100% 100%;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .robot-select-box
  .robot-select-item.robot-active {
  color: #ecf0f9;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .robot-select-box
  .robot-select-item
  .robot-avatar {
  width: 6.67 * 4.2px;
  height: 6.67 * 4.2px;
  -webkit-border-radius: 3.33 * 4.2px;
  border-radius: 3.33 * 4.2px;
  overflow: hidden;
  margin: 2.13 * 4.2px 0 0 1.6 * 4.2px;
  float: left;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .robot-select-box
  .robot-select-item
  .robot-avatar
  img {
  width: 100%;
  height: 100%;
}

.create-battle-page
  .pk-selected-popup-car
  .selected-car-content
  .selected-base-info
  .robot-select-box
  .robot-select-item
  .robot-name {
  float: left;
  width: 21.33 * 4.2px;
  font-size: 4.27 * 4.2px;
  padding-left: 0.93 * 4.2px;
}

.create-battle-page .mask-box {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 50;
}

.pk-room-selected-popup-box {
  background: none;
}

.pk-room-selected-popup-box.popup-box-height-542 {
  height: 72.27 * 4.2px;
}

.pk-room-selected-popup-box.popup-box-height-1002 {
  height: 133.6 * 4.2px;
}

.pk-room-selected-popup-box.popup-box-height-516 {
  height: 68.8 * 4.2px;
}

.pk-room-selected-popup-box.popup-box-height-830 {
  height: 110.67 * 4.2px;
}

.pk-room-selected-popup-box .pk-room-selected-popup-content {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  position: relative;
}

.pk-room-selected-popup-box .pk-room-selected-popup-content .border-top {
  border-top: 1px solid #d8d5f1;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-top {
  height: 6.27 * 4.2px;
  width: 100%;
  padding-top: 5.2 * 4.2px;
  overflow: hidden;
  position: relative;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-top
  p {
  font-size: 3.2 * 4.2px;
  color: #333333;
  float: left;
  margin-left: 4 * 4.2px;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-top
  .selected-num {
  color: #41b256;
  margin-right: 0.67 * 4.2px;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-top
  .selected-total-price {
  color: #ed5f31;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-top
  .selected-total-price
  .bi-icon {
  display: inline-block;
  width: 2.93 * 4.2px;
  height: 3.47 * 4.2px;
  background-size: cover;
  margin-right: 0.27 * 4.2px;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-top
  .close-popup-btn {
  width: 17.07 * 4.2px;
  height: 5.73 * 4.2px;
  border: 0.27 * 4.2px solid #6e86d2;
  font-size: 2.93 * 4.2px;
  color: #9c97d3;
  line-height: 6.27 * 4.2px;
  text-align: center;
  -webkit-border-radius: 3.47 * 4.2px;
  border-radius: 3.47 * 4.2px;
  float: right;
  position: absolute;
  right: 3.33 * 4.2px;
  top: 4.53 * 4.2px;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle {
  width: 100%;
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: auto;
  padding: 2 * 4.2px 3.2 * 4.2px 11.214px 3.33 * 4.2px;
  white-space: nowrap;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.box-selected-list
  .selected-box-item {
  width: 30.67 * 4.2px;
  height: 33.33 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: inline-block;
  margin: 0 0.8 * 4.2px 0 0;
  background-size: cover;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.box-selected-list
  .selected-box-item
  img {
  width: 20.67 * 4.2px;
  height: 20.67 * 4.2px;
  display: block;
  margin: 2 * 4.2px auto 0 auto;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.box-selected-list
  .selected-box-item
  p {
  width: 29.33 * 4.2px;
  margin: 0 auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 2.93 * 4.2px;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.box-selected-list
  .selected-box-item
  .price {
  color: #ffd800;
  height: 4 * 4.2px;
  font-size: 3.2 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-top: 0.27 * 4.2px;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.box-selected-list
  .selected-box-item
  .price
  .bi-icon {
  display: block;
  width: 2.93 * 4.2px;
  height: 3.47 * 4.2px;
  background-size: cover;
  margin-right: 0.53 * 4.2px;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.robot-list {
  height: 23.33 * 4.2px;
  padding: 3.73 * 4.2px 0 11.214px 3.33 * 4.2px;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.robot-list
  .robot-item {
  width: 44.67 * 4.2px;
  height: 17.33 * 4.2px;
  background-size: cover;
  display: inline-block;
  margin-right: 4 * 4.2px;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.robot-list
  .robot-item.active {
  background-size: cover;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.robot-list
  .robot-item.active
  .left-avatar
  .robot_icon {
  background-size: cover;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.robot-list
  .robot-item.active
  .right-robot-info
  .robot-balance,
.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.robot-list
  .robot-item.active
  .right-robot-info
  .robot-record {
  color: #ed5f31;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.robot-list
  .robot-item.active
  .right-robot-info
  .bi-icon {
  background-size: cover;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.robot-list
  .robot-item.active
  .right-robot-info
  .record-icon {
  background-size: cover;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.robot-list
  .robot-item
  .left-avatar {
  width: 20 * 4.2px;
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  float: left;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.robot-list
  .robot-item
  .left-avatar
  .robot-avatar-img {
  width: 10.67 * 4.2px;
  height: 10.67 * 4.2px;
  overflow: hidden;
  -webkit-border-radius: 5.33 * 4.2px;
  border-radius: 5.33 * 4.2px;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.robot-list
  .robot-item
  .left-avatar
  .robot-avatar-img
  img {
  width: 10.67 * 4.2px;
  overflow: hidden;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.robot-list
  .robot-item
  .left-avatar
  .robot_icon {
  width: 7.33 * 4.2px;
  height: 4 * 4.2px;
  background-size: cover;
  position: absolute;
  left: 50%;
  margin-left: -3.67 * 4.2px;
  bottom: 2.27 * 4.2px;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.robot-list
  .robot-item
  .left-avatar
  .pk-status-flag {
  width: 18.4 * 4.2px;
  height: 4 * 4.2px;
  position: absolute;
  left: 50%;
  margin-left: -9.2 * 4.2px;
  bottom: 2.27 * 4.2px;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.robot-list
  .robot-item
  .left-avatar
  .pk-status-flag
  img {
  width: 18.4 * 4.2px;
  height: 4 * 4.2px;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.robot-list
  .robot-item
  .right-robot-info {
  width: 24.67 * 4.2px;
  height: 100%;
  float: left;
  padding-top: 3.73 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 2.93 * 4.2px;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.robot-list
  .robot-item
  .right-robot-info
  .robot-name {
  color: #25223d;
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.robot-list
  .robot-item
  .right-robot-info
  .robot-balance {
  color: #8371e4;
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.robot-list
  .robot-item
  .right-robot-info
  .bi-icon {
  width: 2.4 * 4.2px;
  height: 11.214px;
  display: inline-block;
  background-size: cover;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.robot-list
  .robot-item
  .right-robot-info
  .robot-record {
  color: #8371e4;
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-middle.robot-list
  .robot-item
  .right-robot-info
  .record-icon {
  width: 2.4 * 4.2px;
  height: 2.13 * 4.2px;
  display: inline-block;
  background-size: cover;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-bottom {
  width: 100%;
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .pk-room-selected-popup-bottom
  .create-pk-room-btn {
  width: 41.07 * 4.2px;
  height: 9.33 * 4.2px;
  background-size: cover;
  margin: 11.214px auto 0 auto;
  font-size: 3.47 * 4.2px;
  color: #ffffff;
  text-align: center;
  line-height: 9.87 * 4.2px;
}

.pk-room-selected-popup-box .pk-room-selected-popup-content .auto-open-detial {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding-top: 1.33 * 4.2px;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .auto-open-detial
  .vux-check-icon
  .weui-icon {
  font-size: 3.73 * 4.2px;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .auto-open-detial
  .vux-check-icon
  .weui-icon-success {
  color: #f47759;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .auto-open-detial
  .vux-check-icon
  .weui-icon-success::before {
  color: #f47759;
}

.pk-room-selected-popup-box
  .pk-room-selected-popup-content
  .auto-open-detial
  .vux-check-icon
  > text {
  color: #333333;
  font-size: 3.2 * 4.2px;
}

.create-battle-page {
  height: 100vh;
}

.page-content-bg {
  top: 120px;
}

.type-tab-wrap {
  width: 94.67 * 4.2px;
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-top: 3.47 * 4.2px;
  margin: 0 auto;
  padding-left: 2 * 4.2px;
  color: #fff;
}

.type-tab-wrap .type-tab-item {
  // width: 27.73*4.2px;
  width: 21 * 4.2px;
  height: 9.33 * 4.2px;
  // background: url("../../assets/images/tab_item_def.png") no-repeat 0 0;
  background: url("../../assets/open/2.png") no-repeat 0 0;
  // background-size: 21*4.2px 9.33*4.2px;
  background-size: 100% 100%;
  float: left;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #ffffff;
  margin-right: 2 * 4.2px;
}

.type-tab-wrap .type-tab-item.sel {
  // background: url(data:image/png;base64,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) no-repeat 0 0;
  // background-size: 27.73*4.2px 9.33*4.2px;
  background: url("~@/assets/open/1.png");
  background-size: 100% 100%;
}

@media only screen and (max-width: 430px) {
  .type-tab-wrap {
    width: 94.67vw;

    padding-top: 3.47vw;

    padding-left: 2vw;
  }

  .type-tab-wrap .type-tab-item {
    width: 21vw;
    height: 9.33vw;

    margin-right: 2vw;
  }

  .type-tab-wrap .type-tab-item.sel {
    background: url("~@/assets/open/1.png");
    background-size: 100% 100%;
  }

  .page-content-bg {
    top: 24vw;
  }

  .create-battle-page {
    // padding-top: var(--head-height);
    height: calc(100vh - 20vw);
  }

  .battle-create {
    --head-height: 14vw;
  }

  .create-battle-page .page-content-new {
    padding-bottom: 25.6vw;
  }

  .create-battle-page .page-content-new .detail-content {
    z-index: 1;
    position: relative;
    // -webkit-box-flex: 1;
    // -webkit-flex: 1;
    // -ms-flex: 1;
    // flex: 1;
    width: 100vw;
    height: calc(100vh - 40vw);
    // margin-top: 10vw;
  }

  .create-battle-page .page-content-new .detail-content .inner-content {
    position: relative;
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .create-battle-page
    .page-content-new
    .detail-content
    .inner-content
    .tab-box {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    height: 27vw;
    padding-top: 0vw;
  }

  .create-battle-page
    .page-content-new
    .detail-content
    .inner-content
    .box-list {
    // -webkit-box-flex: 1;
    // -webkit-flex: 1;
    // -ms-flex: 1;
    // flex: 1;
    // overflow-y: auto;
    // overflow-x: hidden;
  }

  .create-battle-page .btm-box {
    z-index: 2;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 44vw;
    -webkit-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
  }

  .create-battle-page .btm-box .top-info {
    position: relative;
    height: 8.4vw;
    background-size: 100% 100%;
    // background-image: url("../../assets/creatroom/21.png");
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAu4AAAB2BAMAAABlmQv+AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAASUExURUNWg0JXgkJXgkNWg0NWg0JWg0ADukgAAAAGdFJOU+bX38/h3LmqeKcAAADBSURBVHja7dBRCQAgEAWwh1jABpbw3w7272KLE2GLsKxBvZMd6vVMCQ80796949073r3j3TvevePdu3e8e8e7d7x7x7t3vHv3jnfvePeOd+94945373j37h3v3vHuHe/e8e4d796949073r3j3TvevePdu3e8e8e7d7x7x7t3vHvHu3fvePeOd+94945373j37h3v3vHuHe/e8e4d7969S/DuHe/e8e4d797x7h3v3r3j3TveveP9u/ct4YGeNah3Lu5uQkc2sktNAAAAAElFTkSuQmCC);

    // background-image: url("../../assets/images/top-info.png");
  }

  .create-battle-page .btm-box .top-info .cancel-all {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    float: left;
    width: 23.33vw;
    height: 8.4vw;
    line-height: 8.4vw;
    text-align: center;
    color: #58deff;
    font-size: 3.33vw;
    padding: 0 0 0 2vw;
    background-size: 100% 100%;
    background-image: url("../../assets/creatroom/20.png");
  }

  .create-battle-page .btm-box .top-info .sel-num {
    float: right;
    height: 4vw;
    line-height: 4vw;
    color: #fff;
    padding: 2vw 5.87vw 0 0;
  }

  .create-battle-page .btm-box .top-info .folder-btn {
    position: absolute;
    top: 2vw;
    left: 47.33vw;
    width: 5.33vw;
    height: 2.93vw;
    -webkit-transform: rotateX(0deg);
    transform: rotateX(0deg);
    -webkit-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    background-size: 100% 100%;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAWCAMAAACFUC6CAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAHsUExURQAAACpV/wBV/yRb/wAAAACA/wAA/wAAQAMFEAMHEwAAAAAAADNm/wAAAFVV/wADCAMFDSBg/wMHFCZZ/wAAAAAAAAAAAAAAAAAAVSJV/ypq/0CA/yhe/yJd/wECByxZ/wIGDyde/y5d/wECBSdd/yNY/0Bg/yZZ/yRJ/ydd/wIGDiRb/yhb/yhb/yZb/y5d/yZb/yZb/ypg/wwdUQYPKv7+/2R9zBYwhKKz6ODn+f///y5LpgAAAAUNJA8lZwoYQwUMIhEobwAAAQEDBwEDCQEDCAQJGAULHwgSMgECBgULHgQIFgcRLg0eUwoYRZOdvhMtfwMIFwYPKQMHFBk6owgUOBxCuQMGEAQJGvv8/VBjnPX3+4qVt+/y/YCTz+3x/QsbTBEdQoKY3AQKHBUrbQkUON7j86Kw2BMpbA0eVBk2jgwcTQgUNwoZRQoXPnmMxmN5wCtGlw4gWxo1iAcRMBUvgA8kZeDm+KKy5Bsydg8kZAweVAoYQhUwhAkVPHiJuhYxhBUwgwscTQsbSy1KowoXQGR9yuDm+RAlaQsaSQsZRi1LpQcQLBAmbAgTNAwdUAsbShAnbBEocGR+zi5Mp2R9yQcQLTZf3ODn+/39/+Hn+qO06g0fVaq//xc2l+Dn+t7k9xEpcTBQtaO38kjvcXIAAAAzdFJOUwAGAw4DAgEEYOFcXQXfA15fCOEobAXo4AMPDAQTHuAX4S4W4CEdCBQHNOA4TC1fCzVrGJJ3HJQAAAHxSURBVCjPY2AAATZWPmk+VjYgg4mHUVBNTZCRh4kNSRgGWBmlZJTUmQWZmBiZ5VWEdXWFVeSZGZmYBJnVlWSkGFnhCnkkZRW1DYSN9DWYVTV19AwN9XQ0VZk19I2EDbQVZSV5wIpExGxsnN08jO3sMnOSwwN9fANCwsJCAnx9AsOTczLt7Iw93JxtbMREGES5xZ1c3O39I9MLy+ocHBJjoq2AIDom0cGhrqwwPdLf3t3FSZxblIGBhYvX1csvKs20oqWjtSQvJS7Wyio2LiWvpLWjpcI0LcrPy5WXiwVkOQuXnHdoRkG5qUV3b2dNUVZSfHxSVlFNZ2+3hWl5QUaotxxEHVAlv4JtQmlbu6mFtaNxU1Vxfn5xVZOxo7WFaXtbaYKtAj8LzNcSApxBxrVmlkCVk/q7mqurm7v6JwHVWZrVGgdxCkggApKdQ8jE2Bys0nFCX09P3wRHsDpzYxMhDnYGBmSVnDCVE+2nTbOfCFPHiaoOWeWUhXPmLJyCSx2SytmL5s1bNBunOrjK+aaLp09fbDofpzq4ylkz586dOQuPOqjKhskzrKxmTG7Aow6qsnHqggVTG/Gqg4RndmV9fWU2evhhMdM2NTc31ZYTvzqgSgGt4IiIYC0BAuqAKvmVPT2V+QmqA6Ylbl5ebhYMYQDvFYSD+dlmYwAAAABJRU5ErkJggg==);
  }

  .create-battle-page .btm-box .sel-box-list {
    position: relative;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    height: 15.73vw;
    -webkit-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    opacity: 1;
    overflow-x: scroll;
    overflow-y: hidden;
    background-size: 100% 100%;
    background: rgba(0, 0, 0, 0.7);
    // background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAu4AAAB2BAMAAABlmQv+AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAASUExURUNWg0JXgkJXgkNWg0NWg0JWg0ADukgAAAAGdFJOU+bX38/h3LmqeKcAAADBSURBVHja7dBRCQAgEAWwh1jABpbw3w7272KLE2GLsKxBvZMd6vVMCQ80796949073r3j3TvevePdu3e8e8e7d7x7x7t3vHv3jnfvePeOd+94945373j37h3v3vHuHe/e8e4d796949073r3j3TvevePdu3e8e8e7d7x7x7t3vHvHu3fvePeOd+94945373j37h3v3vHuHe/e8e4d7969S/DuHe/e8e4d797x7h3v3r3j3TveveP9u/ct4YGeNah3Lu5uQkc2sktNAAAAAElFTkSuQmCC);
  }

  .create-battle-page .btm-box .sel-box-list .sel-box-inner {
    position: absolute;
    top: 0;
    left: 0;
    padding: 0 1.33vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }

  .create-battle-page .btm-box .sel-box-list .box-item {
    position: relative;
    width: 16.4vw;
    height: 15.73vw;
    margin: 0 4.53vw 0 0;
    background: url("~@/assets/creatroom/1.png");
  }

  .create-battle-page .btm-box .sel-box-list .box-item .del-tag {
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    width: 2.67vw;
    height: 2.67vw;
    background-size: 100% 100%;
    background: url("~@/assets/creatroom/19.png") no-repeat center center;
    // background-image: url(data:image/png;base64,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);
  }

  .create-battle-page .btm-box .sel-box-list .box-item .img {
    width: 100%;
    height: 100%;
    -o-object-fit: scale-down;
    object-fit: scale-down;
  }

  .create-battle-page .btm-box .sel-box-list .box-item .price {
    position: absolute;
    left: 0;
    bottom: 1.33vw;
    width: 100%;
    height: 4.8vw;
    line-height: 4.8vw;
    font-size: 3.33vw;
    color: #fff;
    text-align: center;
    background-size: 100% 100%;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAAkCAMAAAB19g5sAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA/UExURTIybTIybDIybSoqajIybjMzZjIybTExbTIybQAAADIybjExbjIybDIybTIybDExbDIybkBAajIybjMzbDExbWHlVyQAAAAVdFJOU8zBwgxmCsPAvgBrur3AwsSzDMFqafJa6tcAAABpSURBVFjD7djbDYAgAEPRIogWVHztP6tMQRPTu8D5bkEyli0vQwvtBDmngOFldPcY72JFlLgdfgM0cIUI3lXwatiwYcOGDRs2bNjwX+BdBVcRfD8aeEpRAk9pZl/IEpc4Wxh7Q+StXCQ/YvsJeIQKL7wAAAAASUVORK5CYII=);
  }

  .create-battle-page .btm-box .opt-box {
    z-index: 3;
    // position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 19.6vw;
    font-size: 4.4vw;
    font-weight: 700;
    background-repeat: no-repeat;
    background-position: bottom center;
    background-size: 100% 14.53vw;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 2vw;
    // background-image: url("../../assets/images/app_ft_2.png");
    // background-color: #1e1d32;
  }

  .create-battle-page .btm-box .opt-box .amount-total {
    float: left;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    height: 7.07vw;
    color: #fff;
    margin: 2.27vw 0 0 1.73vw;
  }

  .create-battle-page .btm-box .opt-box .amount-total .coin {
    width: 5.6vw;
    height: 5.6vw;
    margin-right: 2.67vw;
  }

  .create-battle-page .btm-box .opt-box .create-btn {
    float: right;
    width: 29.07vw;
    height: 9.07vw;
    line-height: 9.07vw;
    text-align: center;
    background-size: 100% 100%;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
  }

  .create-battle-page .btm-box .opt-box .create-btn1 {
    margin: 2.13vw 3.6vw 0 0;
    background-image: url("../../assets/creatroom/18.png");
  }

  .create-battle-page .btm-box .opt-box .create-btn2 {
    margin: 2.13vw 1.87vw 0 0;
    background-image: url("../../assets/creatroom/17.png");
    // background-image: url("../../assets/images/create_btn2.png");
  }

  .create-battle-page .btm-box.fold-box1 {
    height: 28.27vw;
  }

  .create-battle-page .btm-box.fold-box1 .sel-box-list {
    opacity: 0.5;
  }

  .create-battle-page .btm-box.fold-box1 .folder-btn {
    -webkit-transform: rotateX(180deg);
    transform: rotateX(180deg);
  }

  .create-battle-page .sort-wrap {
    height: 4.27vw;
    margin: 2vw 0 4vw 1.33vw;
    position: relative;
    z-index: 5;
  }

  .create-battle-page .sort-wrap .left-sort-box .sort {
    width: auto;
    height: 4.27vw;
    line-height: 4.27vw;
    color: #ecf0f9;
    font-weight: 600;
    cursor: pointer;
    float: left;
    font-size: 3.2vw;
  }

  .create-battle-page .goods-probability {
    padding: 2.67vw 0 0 4vw;
  }

  .create-battle-page .box-list {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }

  .create-battle-page .create-pk-room-content {
    width: 100%;
    overflow: hidden;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
    z-index: 5;
    padding-bottom: 1.33vw;
  }

  .create-battle-page .create-pk-room-content.popup_opended {
    padding-bottom: 16vw;
  }

  .create-battle-page .box-list-wrap {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin: 1.33vw 0 0 1.33vw;
    padding-bottom: 20vw;
  }

  .create-battle-page .box-list-wrap.padding-bottom-542 {
    padding-bottom: 72.27vw;
  }

  .create-battle-page .box-list-wrap.padding-bottom-1002 {
    padding-bottom: 133.6vw;
  }

  .create-battle-page .box-list-wrap.padding-bottom-516 {
    padding-bottom: 68.8vw;
  }

  .create-battle-page .box-list-wrap.padding-bottom-830 {
    padding-bottom: 110.67vw;
  }

  .create-battle-page .box-list-wrap .box-list-item {
    position: relative;
    width: 28.13vw;
    height: 30.87vw;
    color: #fff;
    margin: 0 2.13vw 2.13vw;
    background: linear-gradient(180deg, #5b1ce3 0%, #320f7d 100%);
    box-shadow: inset 0px 0px 6px 0px #6ba0cd;
    border-radius: 2px 2px 2px 2px;
    border: 0px solid #b378e0;
    // background: url("../../assets/images/box_item_bg1.png") center center / 100% 100%;
    // margin-top: 4vw;
  }

  .create-battle-page .box-list-wrap .box-list-item.is-selected {
    background: url("~@/assets/creatroom/16.png");
    background-size: 100% 100%;
    // background: url(data:image/png;base64,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) center center / 100% 100%,
    //   url("../../assets/images/box_item_bg1.png") center center / 100% 100%;
  }

  .create-battle-page .box-list-wrap .box-list-item .detail-btn {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 5.47vw;
    height: 4.13vw;
    background: url("../../assets/images/detail-btn-top.png") no-repeat top
        0.4vw center / 2.67vw 2.67vw,
      url("../../assets/images/detail-btn-bottom.png") center center / 100% 100%;
  }

  .create-battle-page .box-list-wrap .box-list-item .select-opt-box {
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .create-battle-page .box-list-wrap .box-list-item .select-opt-box .sel-num {
    width: 7.33vw;
    height: 4.67vw;
    line-height: 4.67vw;
    font-size: 3.33vw;
    color: #fff;
    text-align: center;
    background-size: 100% 100%;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAAjBAMAAADCso/4AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAYUExURWE5FQAAANOdL//DOP/FNv/FNv/COf/ENxz9AZIAAAAHdFJOU78Ar4B/wD++Rr5zAAAAV0lEQVQoz2Moxw0KGGgmyYADsI9KjkoSllTHI8lUHoBbUr1UAKckU7khbkn1YkGckkCNgg64JIEaRXC5FqQxHZckUKMYrrwC1ogzl5UKiuDOgoGC7kBJAKx5eyEPYkqDAAAAAElFTkSuQmCC);
  }

  .create-battle-page
    .box-list-wrap
    .box-list-item
    .select-opt-box
    .num-opt-box {
    position: absolute;
    left: 50%;
    top: 44%;
    width: 25.33vw;
    height: 5.33vw;
    margin-top: -3.73vw;
    margin-left: -12.67vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    overflow: hidden;
    -webkit-border-radius: 2.67vw;
    border-radius: 2.67vw;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 21.33vw 100%;
  }

  .create-battle-page
    .box-list-wrap
    .box-list-item
    .select-opt-box
    .num-opt-box
    .num-show-box {
    width: 11.2vw;
    height: 5.33vw;
    line-height: 5.33vw;
    margin: 0 1.33vw;
    font-size: 4vw;
    font-weight: 700;
    text-align: center;
    color: #ecf0f9;
  }

  .create-battle-page
    .box-list-wrap
    .box-list-item
    .select-opt-box
    .num-opt-box
    .opt-btn {
    width: 5.73vw;
    height: 5.33vw;
    background-size: 100% 100%;
  }

  .create-battle-page
    .box-list-wrap
    .box-list-item
    .select-opt-box
    .clear-all-btn {
    position: absolute;
    right: 0;
    bottom: 6.27vw;
    width: 6.67vw;
    height: 4vw;
    background-size: 100% 100%;
    background-image: url("../../assets/images/clear-all-btn.png");
  }

  .create-battle-page .box-list-wrap .box-list-item .box-img {
    position: relative;
    height: 20vw;
  }

  .create-battle-page .box-list-wrap .box-list-item .box-img .box-img {
    position: absolute;
    top: 0%;
    left: 0%;
    width: 100%;
    height: 100%;
    -o-object-fit: scale-down;
    object-fit: scale-down;
  }

  .create-battle-page .box-list-wrap .box-list-item .box-info {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    font-size: 3.33vw;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding-left: 2vw;
  }

  .create-battle-page .box-list-wrap .box-list-item .box-info .box-name {
    height: 4.8vw;
    line-height: 4.8vw;
  }

  .create-battle-page .box-list-wrap .box-list-item .box-info .box-price {
    height: 5.33vw;
    line-height: 5.33vw;
  }

  .create-battle-page .box-list-wrap .box-list-item .box-info .box-price text {
    padding-top: 0.27vw;
    font-family: "Alimama ShuHeiTi", serif;
  }

  .create-battle-page .box-list-wrap .box-list-item .box-info .box-price .coin {
    width: 3.27vw;
    height: 3.27vw;
    margin-right: 0.27vw;
  }

  .create-battle-page .pk-selected-popup-car {
    background: none;
    overflow: unset;
    z-index: 2000 !important;
  }

  .create-battle-page .pk-selected-popup-car .selected-car-popup-content {
    width: 100%;
    height: 120vw;
    position: absolute;
    left: 0;
    bottom: 36.53vw;
    z-index: 900;
    --duration: 0.2s;
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#596886),
      to(#19243c)
    );
    background: -webkit-linear-gradient(top, #596886, #19243c 100%);
    background: -o-linear-gradient(top, #596886, #19243c 100%);
    background: linear-gradient(180deg, #596886, #19243c 100%);
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .close-box {
    position: absolute;
    top: -6.13vw;
    left: 0;
    width: 100vw;
    height: 8.27vw;
    background-size: 100% 100%;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .close-box
    .close {
    position: absolute;
    top: 1.6vw;
    right: 2.27vw;
    width: 3.47vw;
    height: 3.47vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-top {
    width: 100%;
    height: 10vw;
    padding-top: 3.33vw;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-top
    .left {
    width: auto;
    height: 6.67vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    color: #c9d5e5;
    font-size: 3.2vw;
    padding-left: 3.2vw;
    float: left;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-top
    .left
    .cancel-all {
    float: left;
    width: 19.33vw;
    height: 5.73vw;
    line-height: 5.73vw;
    font-size: 3.2vw;
    color: #fff;
    text-align: center;
    background-size: 100% 100%;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-top
    .left
    .sel-size {
    color: #3ad7ff;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-top
    .left
    .cancel-all-btn
    .arrow-img {
    display: inline-block;
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
    width: 5.6vw;
    height: 4vw;
    margin: 1.6vw 0 0 1.33vw;
    background-size: 100% 100%;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-top
    .close-btn {
    position: absolute;
    top: 4vw;
    right: 2.8vw;
    width: 4.27vw;
    height: 3.73vw;
    background-size: 100% 100%;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-wrap {
    width: 100%;
    height: 103.73vw;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: hidden;
    overflow-y: auto;
    margin-top: 3.73vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-wrap::-webkit-scrollbar {
    width: 1.33vw;
    height: 1.33vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-wrap::-webkit-scrollbar-thumb {
    background: #666db1;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-wrap::-webkit-scrollbar-track {
    -webkit-border-radius: 0;
    border-radius: 0;
    background: #bfb0c6;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-wrap
    .box-item {
    position: relative;
    width: 93.6vw;
    height: 17.33vw;
    margin-bottom: 2.13vw;
    background-size: 100% 100%;
    margin-left: 2.67vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-wrap
    .box-item
    .box-item-left {
    width: 62.67vw;
    height: 15.33vw;
    padding-left: 7.33vw;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 0.67vw;
    margin-right: 1.33vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    float: left;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-wrap
    .box-item
    .box-item-left
    .box-img {
    position: relative;
    width: 14.4vw;
    height: 14.4vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-wrap
    .box-item
    .box-item-left
    .box-img
    img {
    width: 100%;
    height: 100%;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-wrap
    .box-item
    .box-item-left
    .box-info {
    width: 40.27vw;
    height: 100%;
    padding-left: 2.67vw;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-wrap
    .box-item
    .box-item-left
    .box-info
    .box-name {
    font-size: 3.2vw;
    color: #2f3f60;
    margin-top: 2vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-wrap
    .box-item
    .box-item-left
    .box-info
    .box-price {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    height: 4.8vw;
    line-height: 4.8vw;
    color: #2f3f60;
    font-size: 4vw;
    font-weight: 700;
    margin-top: 2vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-wrap
    .box-item
    .box-item-left
    .box-info
    .box-price
    text {
    font-family: "Alimama ShuHeiTi", serif;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-wrap
    .box-item
    .box-item-left
    .box-info
    .box-price
    .coin {
    width: 4.27vw;
    height: 4.27vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-wrap
    .box-item
    .box-item-right {
    width: 28vw;
    height: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    float: left;
    position: relative;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-wrap
    .box-item
    .box-item-right
    .num-opt-box {
    position: absolute;
    left: 48%;
    top: 72%;
    width: 25.33vw;
    height: 5.33vw;
    margin-top: -3.73vw;
    margin-left: -12.67vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    overflow: hidden;
    -webkit-border-radius: 2.67vw;
    border-radius: 2.67vw;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 21.33vw 100%;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-wrap
    .box-item
    .box-item-right
    .num-opt-box
    .num-show-box {
    width: 11.2vw;
    height: 5.33vw;
    line-height: 5.33vw;
    margin: 0 1.33vw;
    font-size: 4vw;
    font-weight: 700;
    text-align: center;
    color: #ecf0f9;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-wrap
    .box-item
    .box-item-right
    .num-opt-box
    .opt-btn {
    width: 5.73vw;
    height: 5.33vw;
    background-size: 100% 100%;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-popup-content
    .car-popup-content-wrap
    .box-item
    .clear-all {
    position: absolute;
    top: 1.33vw;
    right: 4vw;
    width: 4vw;
    height: 4vw;
    background-size: 100% 100%;
  }

  .create-battle-page .pk-selected-popup-car .selected-box-content {
    position: relative;
  }

  .create-battle-page .pk-selected-popup-car .selected-box-content .close-box {
    position: relative;
    height: 8.27vw;
    -webkit-animation-duration: 0.3s;
    animation-duration: 0.3s;
    background-size: 100% 100%;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-box-content
    .close-box
    .close {
    position: absolute;
    top: 1.6vw;
    right: 2.27vw;
    width: 3.47vw;
    height: 3.47vw;
  }

  .create-battle-page .pk-selected-popup-car .selected-box-content .option-bar {
    height: 13.33vw;
    font-size: 3.73vw;
    margin-top: -1.33vw;
    background-size: 100% 100%;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-box-content
    .option-bar
    .box-size {
    float: left;
    width: 25.07vw;
    height: 10vw;
    margin: 2vw 0 0 1.33vw;
    background-size: 100% 100%;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-box-content
    .option-bar
    .box-size
    .more-op {
    width: 5.07vw;
    height: 5.07vw;
    margin-right: 0.67vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-box-content
    .option-bar
    .box-size
    .len {
    font-weight: 700;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-box-content
    .option-bar
    .total-price {
    float: left;
    width: 43.33vw;
    height: 9.2vw;
    font-size: 4.8vw;
    margin: 2.67vw 0 0 2vw;
    background-size: 100% 100%;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-box-content
    .option-bar
    .total-price
    .coin {
    width: 4.27vw;
    height: 4.27vw;
    margin: -0.4vw 0.67vw 0 0;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-box-content
    .option-bar
    .room-size {
    float: left;
    width: 25.07vw;
    height: 10vw;
    margin: 2vw 0 0 1.87vw;
    background-size: 100% 100%;
  }

  .create-battle-page .pk-selected-popup-car .selected-box-content .btn-box {
    height: 22.93vw;
    background-size: 100% 100%;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-box-content
    .btn-box
    .create-btn {
    width: 40vw;
    height: 10.67vw;
    line-height: 10.67vw;
    text-align: center;
    font-size: 3.73vw;
    font-weight: 700;
    color: #fff2d7;
    margin: 0 6vw;
    background-size: 100% 100%;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-box-content
    .btn-box
    .create-btn
    .btn-pre {
    width: 4.27vw;
    height: 4.27vw;
    margin-right: 0.67vw;
  }

  .create-battle-page .pk-selected-popup-car .selected-car-content {
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 57.33vw;
    z-index: 1000;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .toggle-pk-type {
    position: absolute;
    left: 31.87vw;
    top: 7.73vw;
    width: 36vw;
    height: 7.73vw;
    line-height: 7.73vw;
    z-index: 1300;
    font-size: 3.2vw;
    color: #ecf0f9;
    text-align: center;
    background-size: 100% 100%;
  }

  .create-battle-page .pk-selected-popup-car .selected-car-content .toggle-btn {
    width: 42.8vw;
    height: 7.2vw;
    position: absolute;
    left: 50%;
    top: -7.07vw;
    margin-left: -20.53vw;
    text-align: center;
    line-height: 7.2vw;
    z-index: 1250;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .middle-btns {
    width: 100%;
    height: 8.53vw;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1250;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .middle-btns
    .opt-btn,
  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .middle-btns
    .toggle-btn {
    position: absolute;
    width: 40vw;
    height: 7.2vw;
    text-align: center;
    line-height: 7.2vw;
    z-index: 950;
    font-size: 2.93vw;
    color: #c9d5e5;
    --duration: 0.2s;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .middle-btns
    .sel-size {
    color: #3ad7ff;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-num-btn {
    width: 42.8vw;
    height: 6.67vw;
    background-size: 100% 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-num-btn
    .arrow-icon {
    font-size: 4vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    padding-right: 2.67vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-num-btn
    .arrow-icon
    .arrow-img {
    -webkit-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
    width: 5.6vw;
    height: 4vw;
    background-size: 100% 100%;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-num-btn
    .icon-active
    .arrow-img {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .close-popup-btn {
    position: absolute;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    right: 1.47vw;
    top: 1.73vw;
    z-index: 1300;
    width: 5.33vw;
    height: 5.33vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info {
    width: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    position: absolute;
    left: 0;
    top: 0;
    padding-top: 9.33vw;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 1210;
    margin-top: 5.07vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .base-info-row {
    width: 100%;
    height: 9.33vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-size: 3.73vw;
    font-weight: 700;
    color: #2f3f60;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .base-info-row
    .num-select-item {
    width: 45.07vw;
    height: 12.27vw;
    line-height: 11.33vw;
    text-align: center;
    font-size: 4.27vw;
    background-size: 100% 100%;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .base-info-row
    .num-select-item.num-select-item-active {
    color: #ecf0f9;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .base-info-row.num-select-box {
    height: 10.67vw;
    margin-top: 2.67vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .base-info-row.num-select-box
    .num-select-item {
    margin: 0 4.67vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .base-info-row.num-select-box
    .num-select-item
    .svg-icon {
    font-size: 3.73vw;
    margin-top: 0.4vw;
    margin-right: 0.4vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .base-info-row.bottom-selected-info {
    height: 12vw;
    margin-top: 10.67vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .base-info-row.bottom-selected-info
    .info-item {
    width: 23.47vw;
    height: 10.67vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 3.2vw;
    color: #c9d5e5;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .base-info-row.bottom-selected-info
    .info-item
    .num-btn {
    width: 22.67vw;
    height: 8vw;
    line-height: 8vw;
    font-size: 3.2vw;
    color: #ecf0f9;
    text-align: center;
    background: #8089a0;
    border-top: solid 0.4vw #2f3f60;
    margin: 1.33vw 2vw 0 0;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .base-info-row.bottom-selected-info
    .info-item
    .num-btn
    .edit-ic {
    margin-left: 2vw;
    font-size: 4vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .base-info-row.bottom-selected-info
    .info-item.submit-btn {
    width: 45.2vw;
    height: 12.67vw;
    font-size: 4vw;
    font-weight: 700;
    color: #fff5dc;
    background-size: 100% 100%;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .base-info-row.bottom-selected-info
    .info-item.submit-btn
    .total-price {
    font-size: 4.27vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .base-info-row.bottom-selected-info
    .info-item.submit-btn
    .coin {
    width: 4.27vw;
    height: 4.27vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .base-info-row.bottom-selected-info
    .info-item.submit-btn
    text:last-child {
    margin-left: 1.33vw;
    color: #fff5dc;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .base-info-row.bottom-selected-info
    .info-item
    .img-icon {
    width: 3.2vw;
    height: 3.2vw;
    margin: 0.4vw 0 0;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .base-info-row.bottom-selected-info
    .info-item
    .van-checkbox
    .van-checkbox__label {
    line-height: 4.8vw;
    font-size: 3.2vw;
    color: #2f3f60;
    padding-top: 0.67vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .base-info-row.bottom-selected-info
    .info-item
    .van-checkbox__icon {
    width: 3.47vw;
    height: 3.47vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .base-info-row.bottom-selected-info
    .info-item
    .van-checkbox__icon
    .van-icon {
    width: 3.47vw;
    height: 3.47vw;
    line-height: 3.47vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .base-info-row.bottom-selected-info
    .info-item
    .van-checkbox__icon--checked
    .van-icon {
    color: #ff9f00;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .base-info-row.bottom-selected-info
    .info-item1 {
    background: none;
    padding-top: 0.8vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .robot-select-box {
    width: 100%;
    height: 10.67vw;
    overflow-y: hidden;
    overflow-x: auto;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
    z-index: 1005;
    margin-top: 2.67vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .robot-select-box::-webkit-scrollbar {
    display: none;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .robot-select-box
    .scroll-box {
    width: auto;
    height: 10.67vw;
    padding-left: 2.67vw;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .robot-select-box
    .robot-select-item {
    display: block;
    float: left;
    width: 34.4vw;
    height: 12.27vw;
    line-height: 11.33vw;
    margin-right: 2.27vw;
    padding-left: 1.6vw;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #2f3f60;
    background-size: 100% 100%;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .robot-select-box
    .robot-select-item.robot-active {
    color: #ecf0f9;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .robot-select-box
    .robot-select-item
    .robot-avatar {
    width: 6.67vw;
    height: 6.67vw;
    -webkit-border-radius: 3.33vw;
    border-radius: 3.33vw;
    overflow: hidden;
    margin: 2.13vw 0 0 1.6vw;
    float: left;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .robot-select-box
    .robot-select-item
    .robot-avatar
    img {
    width: 100%;
    height: 100%;
  }

  .create-battle-page
    .pk-selected-popup-car
    .selected-car-content
    .selected-base-info
    .robot-select-box
    .robot-select-item
    .robot-name {
    float: left;
    width: 21.33vw;
    font-size: 4.27vw;
    padding-left: 0.93vw;
  }

  .create-battle-page .mask-box {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 50;
  }

  .pk-room-selected-popup-box {
    background: none;
  }

  .pk-room-selected-popup-box.popup-box-height-542 {
    height: 72.27vw;
  }

  .pk-room-selected-popup-box.popup-box-height-1002 {
    height: 133.6vw;
  }

  .pk-room-selected-popup-box.popup-box-height-516 {
    height: 68.8vw;
  }

  .pk-room-selected-popup-box.popup-box-height-830 {
    height: 110.67vw;
  }

  .pk-room-selected-popup-box .pk-room-selected-popup-content {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    position: relative;
  }

  .pk-room-selected-popup-box .pk-room-selected-popup-content .border-top {
    border-top: 1px solid #d8d5f1;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-top {
    height: 6.27vw;
    width: 100%;
    padding-top: 5.2vw;
    overflow: hidden;
    position: relative;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-top
    p {
    font-size: 3.2vw;
    color: #333333;
    float: left;
    margin-left: 4vw;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-top
    .selected-num {
    color: #41b256;
    margin-right: 0.67vw;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-top
    .selected-total-price {
    color: #ed5f31;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-top
    .selected-total-price
    .bi-icon {
    display: inline-block;
    width: 2.93vw;
    height: 3.47vw;
    background-size: cover;
    margin-right: 0.27vw;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-top
    .close-popup-btn {
    width: 17.07vw;
    height: 5.73vw;
    border: 0.27vw solid #6e86d2;
    font-size: 2.93vw;
    color: #9c97d3;
    line-height: 6.27vw;
    text-align: center;
    -webkit-border-radius: 3.47vw;
    border-radius: 3.47vw;
    float: right;
    position: absolute;
    right: 3.33vw;
    top: 4.53vw;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle {
    width: 100%;
    height: auto;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow-y: hidden;
    overflow-x: auto;
    padding: 2vw 3.2vw 2.67vw 3.33vw;
    white-space: nowrap;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.box-selected-list
    .selected-box-item {
    width: 30.67vw;
    height: 33.33vw;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: inline-block;
    margin: 0 0.8vw 0 0;
    background-size: cover;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.box-selected-list
    .selected-box-item
    img {
    width: 20.67vw;
    height: 20.67vw;
    display: block;
    margin: 2vw auto 0 auto;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.box-selected-list
    .selected-box-item
    p {
    width: 29.33vw;
    margin: 0 auto;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 2.93vw;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.box-selected-list
    .selected-box-item
    .price {
    color: #ffd800;
    height: 4vw;
    font-size: 3.2vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding-top: 0.27vw;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.box-selected-list
    .selected-box-item
    .price
    .bi-icon {
    display: block;
    width: 2.93vw;
    height: 3.47vw;
    background-size: cover;
    margin-right: 0.53vw;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.robot-list {
    height: 23.33vw;
    padding: 3.73vw 0 2.67vw 3.33vw;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.robot-list
    .robot-item {
    width: 44.67vw;
    height: 17.33vw;
    background-size: cover;
    display: inline-block;
    margin-right: 4vw;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.robot-list
    .robot-item.active {
    background-size: cover;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.robot-list
    .robot-item.active
    .left-avatar
    .robot_icon {
    background-size: cover;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.robot-list
    .robot-item.active
    .right-robot-info
    .robot-balance,
  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.robot-list
    .robot-item.active
    .right-robot-info
    .robot-record {
    color: #ed5f31;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.robot-list
    .robot-item.active
    .right-robot-info
    .bi-icon {
    background-size: cover;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.robot-list
    .robot-item.active
    .right-robot-info
    .record-icon {
    background-size: cover;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.robot-list
    .robot-item
    .left-avatar {
    width: 20vw;
    height: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
    float: left;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.robot-list
    .robot-item
    .left-avatar
    .robot-avatar-img {
    width: 10.67vw;
    height: 10.67vw;
    overflow: hidden;
    -webkit-border-radius: 5.33vw;
    border-radius: 5.33vw;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.robot-list
    .robot-item
    .left-avatar
    .robot-avatar-img
    img {
    width: 10.67vw;
    overflow: hidden;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.robot-list
    .robot-item
    .left-avatar
    .robot_icon {
    width: 7.33vw;
    height: 4vw;
    background-size: cover;
    position: absolute;
    left: 50%;
    margin-left: -3.67vw;
    bottom: 2.27vw;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.robot-list
    .robot-item
    .left-avatar
    .pk-status-flag {
    width: 18.4vw;
    height: 4vw;
    position: absolute;
    left: 50%;
    margin-left: -9.2vw;
    bottom: 2.27vw;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.robot-list
    .robot-item
    .left-avatar
    .pk-status-flag
    img {
    width: 18.4vw;
    height: 4vw;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.robot-list
    .robot-item
    .right-robot-info {
    width: 24.67vw;
    height: 100%;
    float: left;
    padding-top: 3.73vw;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 2.93vw;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.robot-list
    .robot-item
    .right-robot-info
    .robot-name {
    color: #25223d;
    height: 4vw;
    line-height: 4vw;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.robot-list
    .robot-item
    .right-robot-info
    .robot-balance {
    color: #8371e4;
    height: 4vw;
    line-height: 4vw;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.robot-list
    .robot-item
    .right-robot-info
    .bi-icon {
    width: 2.4vw;
    height: 2.67vw;
    display: inline-block;
    background-size: cover;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.robot-list
    .robot-item
    .right-robot-info
    .robot-record {
    color: #8371e4;
    height: 4vw;
    line-height: 4vw;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-middle.robot-list
    .robot-item
    .right-robot-info
    .record-icon {
    width: 2.4vw;
    height: 2.13vw;
    display: inline-block;
    background-size: cover;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-bottom {
    width: 100%;
    height: auto;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .pk-room-selected-popup-bottom
    .create-pk-room-btn {
    width: 41.07vw;
    height: 9.33vw;
    background-size: cover;
    margin: 2.67vw auto 0 auto;
    font-size: 3.47vw;
    color: #ffffff;
    text-align: center;
    line-height: 9.87vw;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .auto-open-detial {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    padding-top: 1.33vw;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .auto-open-detial
    .vux-check-icon
    .weui-icon {
    font-size: 3.73vw;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .auto-open-detial
    .vux-check-icon
    .weui-icon-success {
    color: #f47759;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .auto-open-detial
    .vux-check-icon
    .weui-icon-success::before {
    color: #f47759;
  }

  .pk-room-selected-popup-box
    .pk-room-selected-popup-content
    .auto-open-detial
    .vux-check-icon
    > text {
    color: #333333;
    font-size: 3.2vw;
  }
}

// .bottom-content{
//   // height: 0vw;
//   background: rgba(10,0,76,0.36);
// }
</style>
